import { createInstance } from "i18next";
import type { i18n as i18nType } from "i18next";
import FetchBackend from "i18next-fetch-backend";
import { initReactI18next } from "react-i18next";

import { environment } from "../environment";
import { joinPath } from "../utils/joinPath";
import { DEFAULT_LOCALE } from "./constants";

// @ts-ignore imported by rollup plugin
import code from "message-bundle";

type KeyValue = { key: string; value: string };

export const KEY_SEPARATOR = ".";

export const i18n: i18nType = createInstance({
  fallbackLng: DEFAULT_LOCALE,
  keySeparator: KEY_SEPARATOR,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
  defaultNS: [environment.realm],
  ns: [environment.realm],
  backend: {
    loadPath: joinPath(
      environment.adminBaseUrl,
      `resources/{{ns}}/admin/{{lng}}`,
    ),
    parse: (data: string, url?: string) => {
      const messages: KeyValue[] = JSON.parse(data);
      const parsed = Object.fromEntries(
        messages.map(({ key, value }) => [key, value]),
      );
      if (
        process.env.NODE_ENV === "development" &&
        import.meta.env.VITE_REALM_OVERRIDES === undefined
      ) {
        // dev 时 KC 服务器（dist）没有 fork 自有键：把本地 bundle 按请求语言叠加到
        // 服务器返回之上（覆盖同名、补缺键）。上游原实现整体替换为英文包，导致 dev
        // 控制台永远英文、登录页语言选择无效。loadPath 末段即请求的 {{lng}}。
        const lng = url?.split("/").pop() ?? "en";
        const bundles = code as Record<string, Record<string, string>>;
        return { ...parsed, ...(bundles[lng.startsWith("zh") ? "zh-Hans" : lng] ?? {}) };
      }
      return parsed;
    },
  },
});

i18n.use(FetchBackend);
i18n.use(initReactI18next);
